import { faCaravan, faCarSide, faCheck, faCircle, faCog, faCouch, faExclamationTriangle, faEye, faFileAlt, faIdCard, faLightbulb, faThumbsDown, faThumbsUp, faTimesCircle, faTint, faVanShuttle, faWater, faWindowMaximize } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useCallback, useState } from 'react';
import { Form, Row, Col, Container, Button, FormGroup } from 'react-bootstrap';
import parseJwt from '../../utilities/tokenTranslate';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import URLPage from '../../endPoints/endpoints';
import formatNow from '../../utilities/dateNow';
import getVanlist from '../../utilities/getVanList';
import * as listVansActions from "../../redux/listVans/listVansActions"


function FormCheck() {
  const dispatch = useDispatch();
  const token = useSelector((state)=> state.us.current?.token);
 const [formKey, setFormKey] = useState(0);


  
 



  const [formData, setFormData] = useState({
    vehicleRegistrationNumber: '',
    date: '',
    
  });

 





  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
  e.preventDefault();

 
    


  const vanFletData = {
  userMail: parseJwt(token).uid.mail ,
  vehicleRegistrationNumber: formData.vehicleRegistrationNumber.trim().toLocaleUpperCase(),
  bodyWork: formData.bodyWork == "A" ? true : false,
  bodyWorkPanels: formData.bodyWorkPanels == "A" ? true : false,
  mirrors: formData.mirrors == "A" ? true : false,
  mirrorsClean: formData.mirrorsClean == "A" ? true : false,
  windows: formData.windows == "A" ? true : false,
  windowsClean: formData.windowsClean == "A" ? true : false,
  wipers: formData.wipers == "A" ? true : false,
  windScreenWasher: formData.windScreenWasher == "A" ? true : false,
  rearWiper: formData.rearWiper == "A" ? true : false,
  headLights: formData.headLights == "A" ? true : false,
  sideParkingLights: formData.sideParkingLights == "A" ? true : false,
  indicators: formData.indicators == "A" ? true : false,
  brakeLights: formData.brakeLights == "A" ? true : false,
  hazardWarningLights: formData.hazardWarningLights == "A" ? true : false,
  numberPlateLight: formData.numberPlateLight == "A" ? true : false,
  fogLights: formData.fogLights == "A" ? true : false,
  tyreCondition: formData.tyreCondition == "A" ? true : false,
  tyrePressure: formData.tyrePressure == "A" ? true : false,
  tyresDepth: formData.tyresDepth == "A" ? true : false,
  valveCaps: formData.valveCaps == "A" ? true : false,
  wheels: formData.wheels == "A" ? true : false,
  numberPlates: formData.numberPlates == "A" ? true : false,
  numberPlateLight: formData.numberPlateLight == "A" ? true : false,
  engineOil: formData.engineOil == "A" ? true : false,
  coolant: formData.coolant == "A" ? true : false,
  brakeFluid: formData.brakeFluid == "A" ? true : false,
  powerSteeringFluid: formData.powerSteeringFluid == "A" ? true : false,
  leaks: formData.leaks == "A" ? true : false,
  driverSeat: formData.driverSeat == "A" ? true : false,
  pedals: formData.pedals == "A" ? true : false,
  steeringWheel: formData.steeringWheel == "A" ? true : false,
  seatBelts: formData.seatBelts == "A" ? true : false,
  horn: formData.horn == "A" ? true : false,
  warningLights: formData.warningLights == "A" ? true : false ,
  footBrake: formData.footBrake == "A" ? true : false,
  parkingBrake: formData.parkingBrake == "A" ? true : false,
  loadSecurity: formData.loadSecurity == "A" ? true : false,
  vehiculeDocumentation: formData.vehiculeDocumentation == "A" ? true : false,
  warningTrianguleHighVibilityVest: formData.warningTrianguleHighVibilityVest == "A" ? true : false,
  firstAidKit: formData.firstAidKit == "A" ? true : false,
  fireExtinguisher: formData.fireExtinguisher == "A" ? true : false,
  anotherReport: formData.anotherReport.trim(),
  date: formatNow(),
};



axios.post(`${URLPage}/api/van`, vanFletData, {
  headers: {
    'x-token': token,
    'Content-Type': 'application/json'
  }
})
.then(response => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  alert(`Check van flet sent to ${vanFletData.userMail}`);
  
  setFormData({
    anotherReport: '',
    vehicleRegistrationNumber: ''
  });
setFormKey(prev => prev + 1);

getVanlist(0, 10, token)
   .then(res => {
    dispatch(listVansActions.setVansLists(res.data)); 
    })
   .catch(err => {
    console.error(err);
   });


  

  
})
.catch(error => {
  console.error('Error en la petición:', error.response ? error.response.data : error.message);
});
  

};

  return (
    <Container className="p-1">
      <Form key={formKey} onSubmit={handleSubmit}>

        <Form.Group className='bg1 mb-4'>

            <h4 className='ti'>Vehicle Details</h4>
          
            <Row className='bg2'>
            
            <Form.Label><h5>Vehicle Registration Number:</h5> 

              
              </Form.Label>
              <Form.Control 
               className='input1'
               type="text"
               name="vehicleRegistrationNumber"
               //value={formData.vehicleRegistrationNumber}
               //onChange={handleInputChange}
               defaultValue={formData.vehicleRegistrationNumber} 
               onBlur={handleInputChange}
               required
               
            />

           

            </Row>
        </Form.Group>

        {/* Vehihicle Registration Number */}
        <Form.Group className="mb-3 bg1">
          <h4 className='ti'>Exterior Condition</h4>
  
          <Row className='bg2 mb-2' >
             <div className='la'><span>Bodywork: </span>
              { formData.bodyWork == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.bodyWork == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
              
              
              </div>
             <p className='para'>Check for any new dents, scratches, or damage.</p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="bodyWork"
                value="A"
                checked={formData.bodyWork === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="bodyWork"
                value="B"
                checked={formData.bodyWork === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
          </Row>

           <Row className='bg2 mb-3' >
             <div className='la'>Bodywork panels:
              { formData.bodyWorkPanels == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.bodyWorkPanels == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
              
             </div>
             <p className='para'> Ensure all panels are securely fastened.</p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="bodyWorkPanels"
                value="A"
                checked={formData.bodyWorkPanels === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="bodyWorkPanels"
                value="B"
                checked={formData.bodyWorkPanels === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
          </Row>
             <hr/>
            <Row className='bg2 mb-3' >
             <div className='la'>Mirrors:
              { formData.mirrors == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.mirrors == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Check all mirrors (wing mirrors and interior rearview mirror) are present, undamaged, and securely adjusted.</p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="mirrors"
                value="A"
                checked={formData.mirrors === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="mirrors"
                value="B"
                checked={formData.mirrors === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
          </Row>

          
            <Row className='bg2 mb-3' >
             <div className='la'>Mirrors Clean:
              { formData.mirrorsClean == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.mirrorsClean == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Ensure the glass is clean and provides a clear view. </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="mirrorsClean"
                value="A"
                checked={formData.mirrorsClean === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="mirrorsClean"
                value="B"
                checked={formData.mirrorsClean === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
          </Row>
           <hr/>

         <Row className='bg2 mb-3 ' >
             <div className='la'>Windows
              { formData.windows == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.windows == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'> Inspect for any cracks, chips, or damage that could obstruct vision.</p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="windows"
                value="A"
                checked={formData.windows === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="windows"
                value="B"
                checked={formData.windows === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Windows clean
              { formData.windowsClean == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.windowsClean == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Ensure all windows are clean.</p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="windowsClean"
                value="A"
                checked={formData.windowsClean === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="windowsClean"
                value="B"
                checked={formData.windowsClean === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
         <hr/>

         
          <Row className='bg2 mb-3' >
             <div className='la'>Wipers
              { formData.wipers == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.wipers == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Check both dipped and main beam are working.</p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="wipers"
                value="A"
                checked={formData.wipers === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="wipers"
                value="B"
                checked={formData.wipers === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

        <Row className='bg2 mb-3' >
             <div className='la'>Windscreen Washer
              { formData.windScreenWasher == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.windScreenWasher == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Test the windscreen washer fluid level and spray function.</p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="windScreenWasher"
                value="A"
                checked={formData.windScreenWasher === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="windScreenWasher"
                value="B"
                checked={formData.windScreenWasher === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>


        <Row className='bg2 mb-3' >
             <div className='la'>Rear Wiper
              { formData.rearWiper == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.rearWiper == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Check rear wiper (if fitted) for damage and function.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="rearWiper"
                value="A"
                checked={formData.rearWiper === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="rearWiper"
                value="B"
                checked={formData.rearWiper === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <hr></hr>

        <Row className='bg2 mb-3' >
             <div className='la'>Headlights
              { formData.headLights == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.headLights == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Check both dipped and main beam are working.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="headLights"
                value="A"
                checked={formData.headLights === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="headLights"
                value="B"
                checked={formData.headLights === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

        <Row className='bg2 mb-3' >
             <div className='la'>Sidelights (Parking Lights):
              { formData.sideParkingLights == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.sideParkingLights == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Ensure both front and rear are functioning.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="sideParkingLights"
                value="A"
                checked={formData.sideParkingLights === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="sideParkingLights"
                value="B"
                checked={formData.sideParkingLights === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
        <Row className='bg2 mb-3' >
             <div className='la'> Indicators:
              { formData.indicators == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.indicators == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Test all indicators (front, rear, and side repeaters) are working correctly.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="indicators"
                value="A"
                checked={formData.indicators === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="indicators"
                value="B"
                checked={formData.indicators === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Brake Lights:
              { formData.brakeLights == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.brakeLights == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Check all brake lights illuminate when the brake pedal pressed.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="brakeLights"
                value="A"
                checked={formData.brakeLights === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="brakeLights"
                value="B"
                checked={formData.brakeLights === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Hazard Warning Lights:
              { formData.hazardWarningLights == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.hazardWarningLights == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Test all hazard lights are working simultaneously.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="hazardWarningLights"
                value="A"
                checked={formData.hazardWarningLights === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="hazardWarningLights"
                value="B"
                checked={formData.hazardWarningLights === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

        <Row className='bg2 mb-3' >
             <div className='la'>Number Plate Light:
              { formData.numberPlateLight == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.numberPlateLight == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'> Ensure the rear number plate is clearly illuminated.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="numberPlateLight"
                value="A"
                checked={formData.numberPlateLight === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="numberPlateLight"
                value="B"
                checked={formData.numberPlateLight  === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

        <Row className='bg2 mb-3' >
             <div className='la'>Fog Lights:
              { formData.fogLights == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.fogLights == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>Check fog lights

             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="fogLights"
                value="A"
                checked={formData.fogLights === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="fogLights"
                value="B"
                checked={formData.fogLights === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
         <hr/>
         <Row className='bg2 mb-3' >
             <div className='la'>Tyres Condition:
              { formData.tyreCondition == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.tyreCondition == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'> Check for cuts, bulges, or any signs of damage to the
              sidewalls and tread.

             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="tyreCondition"
                value="A"
                checked={formData.tyreCondition === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="tyreCondition"
                value="B"
                checked={formData.tyreCondition === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
       
          <Row className='bg2 mb-3' >
             <div className='la'>Tyres Pressure:
              { formData.tyrePressure == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.tyrePressure == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'> Visually inspect tyres for being underinflated. If
              possible, use a tyre pressure gauge to ensure they meet the recommended pressure (refer to the vehicle handbook or door pillar).

             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="tyrePressure"
                value="A"
                checked={formData.tyrePressure === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="tyrePressure"
                value="B"
                checked={formData.tyrePressure === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Tyres Depth:
              { formData.tyresDepth == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.tyresDepth == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Visually assess the tread depth. In the UK, the legal
              minimum tread depth is 1.6mm across the central three-quarters of the tread and around the entire circumference. 
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="tyresDepth"
                value="A"
                checked={formData.tyresDepth === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="tyresDepth"
                value="B"
                checked={formData.tyresDepth === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <hr/>

         <Row className='bg2 mb-3' >
             <div className='la'>Valve caps:
              { formData.valveCaps == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.valveCaps == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Ensure valve caps are present.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="valveCaps"
                value="A"
                checked={formData.valveCaps === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="valveCaps"
                value="B"
                checked={formData.valveCaps === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
         <hr/>
         <Row className='bg2 mb-3' >
             <div className='la'>Wheels:
              { formData.wheels == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.wheels == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Check for any loose or missing wheel nuts. Inspect wheels for any damage.
             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="wheels"
                value="A"
                checked={formData.wheels === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="wheels"
                value="B"
                checked={formData.wheels === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
         <hr/>
         <Row className='bg2 mb-3' >
             <div className='la'>Number Plates:
              { formData.numberPlates == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.numberPlates == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
               Ensure both front and rear number plates are clean, securely fixed, and
               legally compliant (correct font, size, and spacing).

             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="numberPlates"
                value="A"
                checked={formData.numberPlates === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="numberPlates"
                value="B"
                checked={formData.numberPlates === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
          
        </Form.Group>


      <Form.Group className='bg1 mb-4'>
          <h4 className='ti'>Under the Bonnet</h4>

        <Row className='bg2 mb-3' >
             <div className='la'>Engine Oil:
              { formData.engineOil == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.engineOil == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
               Check the oil level using the dipstick and ensure it is within
               the recommended range.

             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="engineOil"
                value="A"
                checked={formData.engineOil === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="engineOil"
                value="B"
                checked={formData.engineOil === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

        <Row className='bg2 mb-3' >
             <div className='la'>Coolant:
              { formData.coolant == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.coolant == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
               Check the coolant level in the expansion tank and ensure it is
               between the minimum and maximum marks.


             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="coolant"
                value="A"
                checked={formData.coolant === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="coolant"
                value="B"
                checked={formData.coolant === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

        <Row className='bg2 mb-3' >
             <div className='la'>Brake Fluid:
              { formData.brakeFluid == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.brakeFluid == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Check the brake fluid level in the reservoir and ensure it
              is within the recommended range. Do not remove the cap unless
              necessary and if you are competent to do so.

             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="brakeFluid"
                value="A"
                checked={formData.brakeFluid === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="brakeFluid"
                value="B"
                checked={formData.brakeFluid === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
        <Row className='bg2 mb-3' >
             <div className='la'>Power Steering Fluid (if applicable):
              { formData.powerSteeringFluid == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.powerSteeringFluid == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
               Check the fluid level in the reservoir.

             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="powerSteeringFluid"
                value="A"
                checked={formData.powerSteeringFluid === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="powerSteeringFluid"
                value="B"
                checked={formData.powerSteeringFluid === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>         
        <Row className='bg2 mb-3' >
             <div className='la'>Leaks:
              { formData.leaks == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.leaks == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Visually inspect for any signs of leaks under the vehicle.


             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="leaks"
                value="A"
                checked={formData.leaks === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="leaks"
                value="B"
                checked={formData.leaks === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

      </Form.Group>

      <Form.Group className='bg1 mb-4'>
        <h4 className='ti'>Interior Checks</h4>
          <Row className='bg2 mb-3' >
             <div className='la'>Driver Seat:
              { formData.driverSeat == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.driverSeat == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Ensure the driver's seat is adjusted correctly and securely.



             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="driverSeat"
                value="A"
                checked={formData.driverSeat === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="driverSeat"
                value="B"
                checked={formData.driverSeat === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Pedals:
              { formData.pedals == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.pedals == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Check the operation of all pedals (accelerator, brake, clutch) for
              smooth movement and no obstructions.



             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="pedals"
                value="A"
                checked={formData.pedals === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="pedals"
                value="B"
                checked={formData.pedals === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Steering Wheel:
              { formData.steeringWheel == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.steeringWheel == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Ensure the steering wheel operates freely without excessive play.



             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="steeringWheel"
                value="A"
                checked={formData.steeringWheel === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="steeringWheel"
                value="B"
                checked={formData.steeringWheel === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Seat Belts:
              { formData.seatBelts == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.seatBelts == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Check all seat belts are present, undamaged, and function correctly (buckle and release smoothly).




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="seatBelts"
                value="A"
                checked={formData.seatBelts === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="seatBelts"
                value="B"
                checked={formData.seatBelts === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Horn:
              { formData.horn == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.horn == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
               Test the horn to ensure it is working.




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="horn"
                value="A"
                checked={formData.horn === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="horn"
                value="B"
                checked={formData.horn === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Warning Lights:
              { formData.warningLights == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.warningLights == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
               Check that no warning lights (e.g., engine management, ABS, airbag) remain illuminated after the engine has started (unless they are meant to be on, such as the parking brake light).




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="warningLights"
                value="A"
                checked={formData.warningLights === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="warningLights"
                value="B"
                checked={formData.warningLights === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Foot Brake:
              { formData.footBrake == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.footBrake == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Test the footbrake before moving off to ensure it is effective and the vehicle doesn't pull to one side




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="footBrake"
                value="A"
                checked={formData.footBrake === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="footBrake"
                value="B"
                checked={formData.footBrake === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Parking Brake:
              { formData.parkingBrake == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.parkingBrake == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
               Test the parking brake to ensure it holds the vehicle securely on a slight incline.




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="parkingBrake"
                value="A"
                checked={formData.parkingBrake === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="parkingBrake"
                value="B"
                checked={formData.parkingBrake === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

         <Row className='bg2 mb-3' >
             <div className='la'>Load Security:
              { formData.loadSecurity == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.loadSecurity == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Ensure any load is correctly and securely restrained to prevent movement during transit, using appropriate straps, nets, or other securing devices.




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="loadSecurity"
                value="A"
                checked={formData.loadSecurity === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="loadSecurity"
                value="B"
                checked={formData.loadSecurity === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>    

      </Form.Group>

      <Form.Group className='bg1 mb-4'>
            <h4 className='ti'>Documentation and Equipment</h4>
            <Row className='bg2 mb-3' >
             <div className='la'>Vehicle Documentation:
              { formData.vehiculeDocumentation == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.vehiculeDocumentation == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
              Ensure necessary documents (e.g., vehicle registration, insurance details) are present in the vehicle (if required by company policy).





             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="vehiculeDocumentation"
                value="A"
                checked={formData.vehiculeDocumentation === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="vehiculeDocumentation"
                value="B"
                checked={formData.vehiculeDocumentation === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

        <Row className='bg2 mb-3' >
             <div className='la'>Warning triangle and high-visibility vest:
              { formData.warningTrianguleHighVibilityVest == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.warningTrianguleHighVibilityVest == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
             Check for the presence of a warning triangle and high-visibility vest (as recommended or required by company policy).




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="warningTrianguleHighVibilityVest"
                value="A"
                checked={formData.warningTrianguleHighVibilityVest === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="warningTrianguleHighVibilityVest"
                value="B"
                checked={formData.warningTrianguleHighVibilityVest === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>
         <Row className='bg2 mb-3' >
             <div className='la'>First-aid kit:
              { formData.firstAidKit == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.firstAidKit == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
             Ensure the first-aid kit is present and adequately stocked (if provided).




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="firstAidKit"
                value="A"
                checked={formData.firstAidKit === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="firstAidKit"
                value="B"
                checked={formData.firstAidKit === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>

            <Row className='bg2 mb-3' >
             <div className='la'>Fire extinguisher:
              { formData.fireExtinguisher == "A"  &&
              <FontAwesomeIcon  icon={faCheck} style={{ color: 'green', marginLeft: '4px' }} /> 
              }

              { formData.fireExtinguisher == "B"  &&
              <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', marginLeft: '4px' }} /> 
              }
             </div>
             <p className='para'>
             Check the functionality of any fire extinguisher (if provided and applicable).




             </p>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Satisfactory"
                name="fireExtinguisher"
                value="A"
                checked={formData.fireExtinguisher === 'A'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsUp}/></div>
            </Col>
            <Col className='d-flex'>
              <Form.Check
                type="radio"
                label="Not Satisfactory"
                name="fireExtinguisher"
                value="B"
                checked={formData.fireExtinguisher === 'B'}
                onChange={handleInputChange}
                required
              />
              <div className='thumbs'><FontAwesomeIcon icon={faThumbsDown}/></div>
            </Col>
         </Row>              

      </Form.Group>
      
            <Form.Group className='bg1 mb-4'>
            <h4 className='ti'>Additonal Report (optional)</h4>

            <Row className='bg2 mb-3'>
              <Col>
               <textarea
            className="form-control"
            style={{ resize: 'none' }}
            rows="5"
            placeholder="Write here...max length 400 caracters"
            name="anotherReport"
            defaultValue={formData.anotherReport}
            onBlur={handleInputChange}
            maxLength="400"
            />
            </Col>
            </Row>
            </Form.Group>
      






        <Button type="submit" variant="primary">Send</Button>
      </Form>
      
    </Container>
  );
}

export default FormCheck;


